import React from "react"
import { Grid, IconButton } from "@material-ui/core"
import { Add, Remove } from "@material-ui/icons"

import { SectionContainer, ButtonsContainer } from "./styles"
import { FormHelperText, FormTextField } from "../../../../../components/Form"
import { toMask } from "../../../../../services/masks"
import { cnpj } from "../../../../../consts/regexp"
import { useControlledArray } from "../../../../../hooks"

export function NetworkCompanies() {
  const { data, add, remove } = useControlledArray([{ id: "0" }])

  function handleAdd(index) {
    const newRegister = {
      id: String(index + 1),
    }

    add(newRegister)
  }

  return (
    <SectionContainer>
      {data.map((register, index) => {
        const disabledAddButton = index !== data.length - 1
        const disabledRemoveButton = data.length === 1 || disabledAddButton

        return (
          <Grid key={register.id} container spacing={2} alignItems="flex-start">
            <Grid item xs={12} sm={3}>
              <FormTextField
                fullWidth
                label="CNPJ"
                size="small"
                variant="outlined"
                name={`network_companies.${index}.cod_coligada`}
                textMaskProps={toMask(cnpj.array)}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <FormTextField
                fullWidth
                label="Nome"
                size="small"
                variant="outlined"
                name={`network_companies.${index}.dsc_empresa_col`}
              />
            </Grid>
            <Grid item xs={12} sm={1}>
              <ButtonsContainer>
                <IconButton
                  disabled={disabledAddButton}
                  color="primary"
                  title="Adicionar"
                  size="small"
                  onClick={() => handleAdd(index)}
                >
                  <Add />
                </IconButton>

                <IconButton
                  disabled={disabledRemoveButton}
                  className="remove"
                  title="Remover"
                  size="small"
                  onClick={() => remove(register.id)}
                >
                  <Remove />
                </IconButton>
              </ButtonsContainer>
            </Grid>
          </Grid>
        )
      })}

      <FormHelperText name="network_companies" />
    </SectionContainer>
  )
}
